import * as EventListener from "../../../common/helpers/event-listener";

const changePaymentMethod = () => {
    EventListener.change("change-payment-method-select", (select) => {
        document
            .querySelectorAll(".payment-method-description")
            .forEach((element) => {
                element.classList.add("hidden");
            });

        document
            .getElementById(`payment-method-description-${select.value}`)
            .classList.remove("hidden");

        select.disabled = false;
    });
};

changePaymentMethod();
